const views = {
    UserProfile: "UserProfile",
    W4: "W4",
    I9: "I9",
    I9Signature: "I9Signature",
    DirectDeposit: "DirectDeposit",
    Confirmation: "Confirmation",
    FederalW4Signature: "FederalW4Signature",
    FederalW4: "FederalW4"
}

/**
 * A service intended to manage state for a manual request submission form.
 */
export class OnboardingDocumentViewService {
    /**
     * Construct a service coordinating state flow for a submission form instance.
     * @param {import("angular").IQService} $q
     * @param {import("angular-ui-router").IStateService} $state
     */
    constructor($q, $state) {
        'ngInject';
        this.$q = $q;
        this.$state = $state;
    }

    /**
     * Construct and return the initial state for the form based on supplied
     * default values.
     */
    initializeSubmissionForm() {
        const state = {
            view: views.UserProfile
        };

        const resolveState = this.$q.resolve(state);

        return resolveState.then((resolvedState) => {
            return this.$state.go("onboarding-document.userProfile");
            //return state;
        });
    }

    /**
     * Return the updated state for displaying the submission preview.
     * @param {any} state The current state.
     */
    showW4Form(state) {
        console.log(state);
        return this.$q.resolve()
            .then(() => { })
            .then(i => ({
                ...state,
                view: views.W4
            }));
    }

    showI9Form(state) {
        return this.$q.resolve()
            .then(() => { })
            .then(i => ({
                ...state,
                view: views.I9
            }));
    }

    showI9SignatureForm(state) {
        return this.$q.resolve()
            .then(() => { })
            .then(i => ({
                ...state,
                view: views.I9Signature
            }));
    }

    showFederalW4(state) {
        return this.$q.resolve()
            .then(() => { })
            .then(i => ({
                ...state,
                view: views.FederalW4
            }));
    }

    showFederalW4Signature(state) {
        return this.$q.resolve()
            .then(() => { })
            .then(i => ({
                ...state,
                view: views.FederalW4Signature
            }));
    }

    showUserProfile(state) {
        return this.$q.resolve({
            ...state,
            view: views.UserProfile
        });
    }

    showDirectDepositForm(state) {
        return this.$q.resolve()
            .then(() => { })
            .then(i => ({
                ...state,
                view: views.DirectDeposit
            }));
    }

    showConfirmationForm(state) {
        return this.$q.resolve()
            .then(() => { })
            .then(i => ({
                ...state,
                view: views.Confirmation
            }));
    }
}
